/**
 * LHAS-1897
 * This function add several css classes to the html element, to show whether the browser supports css3 features,
 * like animations or transitions.
 */
(function() {
    "use strict";

    var docElem = document.documentElement,
        classesToAdd = [
            "cssanimations",
            "cssgradients",
            "csstransforms",
            "csstransforms3d",
            "csstransitions"
        ],
        i;

    // Removes all classes from the array, whose opposite part (e.g. "no-cssanimations" and "cssanimations") is already on the html element.
    for (i = 0; i < classesToAdd.length; i++) {
        if (docElem.classList.contains("no-" + classesToAdd[i])) {
            classesToAdd.splice(i, 1);
            i--;
        }
    }

    docElem.classList.add.apply(docElem.classList, classesToAdd);
})();
